import { FEATURES } from '@constants/Text'
import chatModule from '@modules/client-journey/store/chat'
import storeModule from '@modules/client-journey/store'
import { isClientJourneyEnabled } from '@modules/client-journey/utils/journey-enabled/journey-enabled'

export const NAMESPACE = 'clientJourney'
// Namespace SEPARADO para o chat: misturar com o do aawz-intelligence-v2 faria
// a conversa da jornada vazar para o chat do IA Operacional.
export const CHAT_NAMESPACE = 'clientJourneyChat'

export function clientJourneyModule({ store }) {
  if (!store) return
  store.registerModule(NAMESPACE, { namespaced: true, ...storeModule })
  store.registerModule(CHAT_NAMESPACE, { namespaced: true, ...chatModule })
  aplicarOverrideDeDev(store)
}

// ATENCAO: tem que ser AQUI, no bootstrap, e não num `created()` de layout.
// `registerAllModules()` é aguardado em `main.js` ANTES da primeira navegação;
// o layout só é criado DEPOIS que o guard da rota resolveu. Aplicar no layout
// fazia um F5 direto em /resumo-cliente cair em "Página não encontrada", porque
// o guard lia `meta.can_show` com a flag ainda desligada — reproduzido em QA.
function aplicarOverrideDeDev(store) {
  if (!isClientJourneyEnabled(store.getters['parameters/show'])) return
  store.dispatch('parameters/updateShowModule', {
    module: FEATURES.CLIENT_JOURNEY,
    value: true,
  })
}
